import React, { useEffect, useState } from "react";
import { clientActions, reservationsActions, useSelector } from "inbooma-api";
import { Biscuit } from "../../../../utils";
import ClientSelect from "./components/ClientSelect";
import SupportView from "./SupportView";

const HelpdeskView = (props) => {
  const { dispatch } = props;
  const language = Biscuit.get("user.lang").replace("-", "_");
  const [clientsPending, setClientsPending] = useState(false);
  const _clients = useSelector((state) => state["client_data"].clients);
  const [clients, setClients] = useState(null);
  const [client, setClient] = useState(null);
  const [initialized, setInitialized] = useState(false);
  const [reservation, setReservation] = useState(null);
  const [reservations, setReservations] = useState(null);
  const [users, setUsers] = useState(null);
  const [user, setUser] = useState(null);
  const [reservationQuery, setReservationQuery] = useState("");
  const [userQuery, setUserQuery] = useState("");
  const _reservationsGlobal = useSelector((state) => state.reservations.getReservations);
  const [reservationsGlobalPending, setReservationsGlobalPending] = useState(false);
  const [reservationsGlobal, setReservationsGlobal] = useState(null);

  useEffect(() => {
    if (
      _reservationsGlobal.success == "" ||
      !reservationsGlobalPending ||
      clientsPending ||
      client === null
    )
      return;

    if (_reservationsGlobal.success === true) {
      setReservationsGlobal([..._reservationsGlobal.data]);
    } else {
      console.log("Failed to request reservations!");
    }
    setReservationsGlobalPending(false);
    dispatch(reservationsActions.getReservationsResetData());
  }, [_reservationsGlobal]);

  useEffect(() => {
    if (!initialized && !clientsPending) {
      dispatch(
        clientActions.getClients({
          suffix: "",
          filter: {
            find: "completeSelect",
            useSupport: 1,
          },
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setClientsPending(true);
    }
  }, []);

  useEffect(() => {
    if (!clientsPending || _clients.success === "") {
      return;
    }
    if (_clients.success === true) {
      setClients(_clients.data);
    }
    setInitialized(true);
    setClientsPending(false);
  }, [_clients]);

  const getReservationsGlobal = (client) => {
    /* if(typeof client.id !== 'undefined'){
            dispatch(reservationsActions)
        }*/
  };

  return (
    <>
      <div id="inb-c-main-helpdesk" className="off-canvas-wrapper">
        {!clientsPending && initialized && (
          <ClientSelect
            clients={clients}
            client={client}
            setClient={setClient}
            setUsers={setUsers}
            setUser={setUser}
            setReservations={setReservations}
            setReservation={setReservation}
            setReservationQuery={setReservationQuery}
            setUserQuery={setUserQuery}
            setReservationsGlobal={reservationsGlobal}
            dispatch={dispatch}
          />
        )}
        {client !== null && (
          <SupportView
            dispatch={dispatch}
            client={client}
            clientId={client?.id}
            language={language}
            users={users}
            setUsers={setUsers}
            user={user}
            setUser={setUser}
            reservations={reservations}
            setReservations={setReservations}
            reservation={reservation}
            setReservation={setReservation}
            reservationQuery={reservationQuery}
            setReservationQuery={setReservationQuery}
            userQuery={userQuery}
            setUserQuery={setUserQuery}
          />
        )}
      </div>
    </>
  );
};
export default HelpdeskView;
